import _map from 'lodash/map'

import Title from 'components/Title'
import CardService from 'components/Card/CardService'
import Link from 'components/Link'

import Styled from './styled'

import { categories } from 'constant/data'

export default function SectionOurService({ data }) {
  const title = data?.title
  // const categories = _filter(data?.newCategories)

  return (
    <Styled id="section-service">
      <Title level={1}>{title}</Title>

      <div className="service-content">
        {_map(categories, (item, index) => {
          const name = item?.name
          const image = item?.image?.url
          const slug = item?.url
          const link = `/${slug}`
          return (
            <div key={index}>
              <Link href={link}>
                <CardService title={name} image={image} eager={index < 2} />
              </Link>
            </div>
          )
        })}
      </div>
    </Styled>
  )
}
